import React from 'react'

// prettier-ignore
export const Contract = {
  Dashboard: React.lazy(() => import('./dashboard')),
  Create:    React.lazy(() => import('./create')),
  Edit:      React.lazy(() => import('./edit')),
}
